// Integrytas Group — inline-toggle suppression.
// Inside the real shell, personalization is driven from ONE control in the title
// bar. The existing per-page/per-modal <PersonalizationToggle/> calls therefore
// render null when they sit under this context (which wraps the page region only,
// not the header). Rendered standalone (the §17 conformance test), the context is
// absent → the toggle draws inline → the gate stays green with no page edits.

import { createContext, useContext } from 'react';

export const SuppressInlineToggleContext = createContext(false);

export function useSuppressInlineToggle(): boolean {
  return useContext(SuppressInlineToggleContext);
}
